import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import './styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
// import ObjectiveView from '../../../widgets/projectProposal/objectiveGoal/ObjectiveView'
import GoalWidget from '../../../widgets/projectProposal/objectiveGoal/GoalWidget'
import ObjctiveWidget from '../../../widgets/projectProposal/objectiveGoal/ObjctiveWidget'
import ResultWidget from '../../../widgets/projectProposal/objectiveGoal/ResultWidget'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getSubProjectIndicators,
  getSubProjectObjectiveGoal,
  getSubProjectObjective,
} from '../../../redux/actions/objectiveGoal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function ObjectiveGoal() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [indicatorForm, setIndicatorForm] = useState()
  const [showEditAll, setShowEditAll] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('load ObjectiveGoal projectId', projectId)

    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjectObjectiveGoal(proposalId)

      setSchema(_schema)
      setIndicatorForm(_schema?.forms?.indicator)
      setIsEditWidget({
        goal: _schema.forms?.goal?.goal?.value?.length > 0 ? false : true,
        objective: _schema.forms?.objective?.objective?.value?.length > 0 ? false : true,
        indicator: _schema.forms?.indicator?.indicatorsResult?.value?.length > 0 ? false : true,
      })
      setShowEditAll(
        !_schema.forms?.goal?.disabled &&
          !_schema.forms?.objective?.disabled &&
          !_schema.forms?.indicator?.disabled
      )
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetIndicator = async () => {
    try {
      const _schema = await getSubProjectIndicators(projectId)
      // console.log('handleGetIndicator', _schema)
      setIndicatorForm(_schema)
    } catch (e) {}
  }

  const handleOnSuccess = async (res) => {
    if (res) {
      try {
        const _schema = await getSubProjectObjective(projectId)
        setSchema((state) => ({
          ...state,
          forms: {
            ...state.forms,
            objective: _schema,
          },
        }))
      } catch (e) {
        console.log('error', e)
      }
    }
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProject>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {showEditAll && (
          <BtnEditAll
            onClickEditAll={getIsEditAll(isEditWidget)}
            setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          />
        )}

        {/* วัตถุประสงค์ */}
        {schema?.forms?.objective && (
          <>
            <ObjctiveWidget
              showCommandButton={!schema.forms.objective.disabled}
              schema={schema.forms.objective}
              isEdit={isEditWidget.objective}
              isSubProject={true}
              handleGetIndicator={handleGetIndicator}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('objective', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}

        {/* ผลลัพธ์และตัวชี้วัด */}
        {indicatorForm && (
          <>
            <ResultWidget
              showCommandButton={!indicatorForm.disabled}
              schema={indicatorForm}
              isEdit={isEditWidget.indicator}
              isSubProject={true}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('indicator', _isEdit, setIsEditWidget)
              }
              onSuccess={(res) => handleOnSuccess(res)}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
